import {AdvancedFilterFieldTypesEnum, IAdvanceFilter} from '../../shared/advanced-filters/components/advance-filter';
import {RequestBuilder} from '../documents/store/request-builder';
import {IMetadataItemDto} from '../settings/documentfields/metadata-item.dto';
import {ContractControlAdvanceFilterParamType, ICCGeneralDataAdvancedFilter} from './advanced-filters';
import {IContractControlSearchParams} from './store/dto/contract-control-view';

export class GetContractControlRequestBuilder extends RequestBuilder<IContractControlSearchParams> {
    private advanceFilterBuilder: CCAdvancedFilterBuilder = new CCAdvancedFilterBuilder();
    private readonly noCategoryId = -1;
    private readonly noCategoryValue = 'no_category';
    
    constructor() {
        super();
        this.request.page = 1;
    }

    page(page: number) {
        this.request.page = page > 0 ? page : 1;
        return this;
    }

    updatePerPageRecord(recordLength: number){
        this.request.per_page_records = recordLength > 20 ? recordLength : 20; 
    }

    search(searchQuery: string) {
        if (typeof searchQuery === 'string' && searchQuery?.trim().length > 0) {
            if(searchQuery?.startsWith('?')){
                this.request.ai_query = searchQuery;
                delete this.request.q;
            }else{
                this.request.q = searchQuery;
            }

        } else {
            delete this.request.q;
            delete this.request.ai_query;
        }

        return this;
    }

    categories(categoryIds: number | number[] | string) {
        const normalized = Array.isArray(categoryIds) ? categoryIds[0] : categoryIds;
        const isNoCategory = normalized === this.noCategoryId || normalized === this.noCategoryValue;
        if (isNoCategory) {
            this.request.category_ids = this.noCategoryValue;
        } else if (categoryIds) {
            this.request.category_ids = categoryIds as number | number[];
        } else {
            delete this.request.category_ids;
        }

        return this;
    }

    documentType(id: number) {
        if (id != null) {
            this.request.document_type_id = id;
        } else {
            delete this.request.document_type_id;
        }

        return this;
    }


    status(status:string) {
        if(status!=null && status!='all'){
            this.request.status = status;
        }else{
            delete this.request.status
        }

        return this;
    }

    advancedFilters(filters:   IAdvanceFilter<ContractControlAdvanceFilterParamType>[]) {
        if (filters?.length > 0) {
            this.request.advanced = this.advanceFilterBuilder.build(filters);
        } else {
            delete this.request.advanced;
        }

        return this;
    }



}

export class CCAdvancedFilterBuilder {
    
    build(filters: IAdvanceFilter<ContractControlAdvanceFilterParamType>[]) {
       return  filters.map(adv => {
            return this.createAdvanceFilterPayload(adv)
        });
    }

    private createAdvanceFilterPayload(adv: IAdvanceFilter<ContractControlAdvanceFilterParamType>): ContractControlAdvanceFilterParamType {
        switch (adv.field_type) {
            case AdvancedFilterFieldTypesEnum.general_field: {
                return ({
                    field_type: AdvancedFilterFieldTypesEnum.general_field,
                    value: adv.value,
                    operator: adv.operator,
                    general_data_type: (adv?.item as ICCGeneralDataAdvancedFilter)?.general_data_type,
                }) as ContractControlAdvanceFilterParamType
            }
            case AdvancedFilterFieldTypesEnum.document_field:
                return ({
                    field_type: adv.field_type,
                    meta_data_id: (adv.item as IMetadataItemDto)?.id,
                    value: adv.value,
                    operator: adv.operator,
                    condition_type: adv.condition_type
                } as ContractControlAdvanceFilterParamType);


            case AdvancedFilterFieldTypesEnum.condition:
                return ({
                    field_type: AdvancedFilterFieldTypesEnum.condition,
                    condition_type: adv.condition_type
                } as ContractControlAdvanceFilterParamType);
        }
    }
}
